import { useNavigate } from 'react-router-dom';

import { useQueryClient } from '@tanstack/react-query';

import { useAuthStore } from '../../../core';

/** Clear the session + cached data, then send the user back to /login. */
export const useLogout = () => {
  const clear = useAuthStore((s) => s.clear);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return () => {
    clear();
    queryClient.clear();
    navigate('/login', { replace: true });
  };
};
